import { createContext, useContext, useState } from "react";

const NavContext = createContext();

function NavProvider({ children }) {
  const [search, setSearch] = useState(false);
  const [nav2Content, setNav2Content] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <NavContext.Provider
      value={{
        search,
        setSearch,
        nav2Content,
        setNav2Content,
        isSidebarOpen,
        setIsSidebarOpen,
      }}
    >
      {children}
    </NavContext.Provider>
  );
}

function useNav() {
  const context = useContext(NavContext);
  if (context === undefined)
    throw new Error("Context can't be used outside of the context provider");
  return context;
}

export { NavProvider, useNav };
